module.exports = __webpack_public_path__ + "img/zizhi3.4e4454b0.png";